/** @file tileBindingLabels: the human label of every Tile screen binding (Settings shows them). */

/** Binding id to label for `tileBindings`. */
export const tileBindingLabels: Readonly<Record<string, string>> = {
  'tile.pencil': 'Tile: pencil (Alt+click picks, Shift+click draws a line)', 'tile.eraser': 'Tile: eraser',
  'tile.bucket': 'Tile: bucket fill', 'tile.eyedropper': 'Tile: eyedropper', 'tile.line': 'Tile: line',
  'tile.mirror': 'Tile: Mirror X across the pivot column', 'tile.onion': 'Tile: onion (neighbouring tiles)',
  'tile.grid': 'Tile: pixel grid', 'tile.zoomFit': 'Tile: zoom to fit', 'tile.zoomIn': 'Tile: zoom in', 'tile.zoomOut': 'Tile: zoom out',
  'tile.undo': 'Tile: undo a stroke', 'tile.redo': 'Tile: redo a stroke', 'tile.redoAlt': 'Tile: redo a stroke (Ctrl+Y)',
  'tile.save': 'Tile: Save (upload and fill the slot)', 'tile.close': 'Tile: close the tab',
};
